import { LocalStorageKeys } from "@/types/local-storage.types";

const LOCAL_STORAGE: Record<LocalStorageKeys, LocalStorageKeys> = {
  accessTokenKey: "accessTokenKey",
  refreshTokenKey: "refreshTokenKey",
  rememberMe: "rememberMe",
  lang: "lang",
  expiredPassword: "expiredPassword",
};

export default LOCAL_STORAGE;
